export var PLATFORM_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export var PLATFORM_DATE_FORMAT = 'YYYY-MM-DD';
export var PLATFORM_MONTH_FORMAT = 'YYYY-MM';